export default __webpack_public_path__ + "static/media/error.f4efc033.svg";